export const LOGO_URL =
  'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/2f3562555a02a123f94de0ddfbed110b.png';

export interface NavLink {
  label: string;
  href: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: 'Benefícios', href: '#solucoes' },
  { label: 'Como funciona', href: '#como-funciona' },
  { label: 'Prêmios', href: '#premios' },
  { label: 'Suporte ao premiado', href: '#suporte-premiado' },
  { label: 'Segmentos', href: '#segmentos' },
  { label: 'Cases', href: '#cases' },
  { label: 'FAQ', href: '#faq' },
];

export const HERO_PHONE_IMAGE =
  'https://public.readdy.ai/ai/img_res/6d1ca358-f88b-48a0-98c9-29890d25352e.png';

export interface HeroCard {
  title: string;
  description: string;
  icon: string;
  iconBg: string;
  position: string;
}

export const HERO_CARDS: HeroCard[] = [
  {
    title: 'Campanhas de Incentivo',
    description: 'Metas, rankings e desafios criados para direcionar comportamento.',
    icon: 'ri-flag-2-line',
    iconBg: 'bg-primary-100 text-primary-700',
    position: 'left-[1%] top-[12%]',
  },
  {
    title: 'Gamificação e XP',
    description: 'Níveis, distintivos e missões que mantêm o time engajado.',
    icon: 'ri-trophy-line',
    iconBg: 'bg-accent-100 text-accent-700',
    position: 'right-[1%] top-[24%]',
  },
  {
    title: 'Marketplace e Resgate',
    description: 'Produtos, vouchers e cartão digital com resgate em poucos cliques.',
    icon: 'ri-gift-line',
    iconBg: 'bg-secondary-100 text-secondary-800',
    position: 'left-[3%] top-[58%]',
  },
  {
    title: 'Premiação e PIX',
    description: 'Pague com PIX ou cartão digital com a menor taxa do mercado.',
    icon: 'ri-bank-card-line',
    iconBg: 'bg-primary-100 text-primary-700',
    position: 'right-[3%] bottom-[10%]',
  },
];

export interface HeroStat {
  value: string;
  label: string;
  icon: string;
}

export const HERO_STATS: HeroStat[] = [
  { value: '+100', label: 'empresas confiam', icon: 'ri-team-fill' },
  { value: '+80 mil', label: 'de pessoas engajadas', icon: 'ri-smartphone-fill' },
  { value: '+150 campanhas', label: 'realizadas com sucesso', icon: 'ri-chat-3-fill' },
  { value: '+85%', label: 'de aumento médio em vendas', icon: 'ri-bar-chart-fill' },
];

export interface BentoStat {
  value: string;
  suffix: string;
  description: string;
}

export const BENTO_STATS: BentoStat[] = [
  {
    value: '100',
    suffix: '%',
    description:
      'dos participantes recebem comunicações personalizadas de acordo com a sua evolução e o seu momento na campanha.',
  },
  {
    value: '24',
    suffix: 'h',
    description:
      'para consultar metas, campanhas, ranking, pontos e premiações de qualquer lugar, direto pelo celular.',
  },
];

export interface BentoFeatureCardData {
  icon: string;
  titleLead: string;
  titleAccent: string;
  description: string;
  checklist: string[];
}

export const BENTO_FEATURE: BentoFeatureCardData = {
  icon: 'ri-brain-line',
  titleLead: 'IA que entende',
  titleAccent: 'cada participante',
  description:
    'A GetPoints IA entende o momento de cada pessoa e personaliza a comunicação para aumentar o engajamento e acelerar os resultados.',
  checklist: ['Mensagens personalizadas', 'Recomendações inteligentes', 'Ações no momento certo'],
};

export interface BentoStatCardData {
  value: string;
  suffix: string;
  heading: string;
  description: string;
  icon: string;
  iconPosition: 'left' | 'right';
  footerIcon: string;
  footerLines: string[];
}

export const BENTO_STAT_CARDS: BentoStatCardData[] = [
  {
    value: '100',
    suffix: '%',
    heading: 'Comunicação personalizada',
    description:
      'Todos os participantes recebem comunicações de acordo com seu perfil, evolução e momento na campanha.',
    icon: 'ri-send-plane-line',
    iconPosition: 'right',
    footerIcon: 'ri-bar-chart-2-line',
    footerLines: ['Mais relevância.', 'Mais engajamento. Mais resultados.'],
  },
  {
    value: '24',
    suffix: 'h',
    heading: 'Tudo na palma da mão',
    description:
      'Consulte metas, campanhas, ranking, pontos e premiações a qualquer hora, direto pelo celular.',
    icon: 'ri-time-line',
    iconPosition: 'left',
    footerIcon: 'ri-smartphone-line',
    footerLines: ['Autonomia para o participante.', 'Mais agilidade para o seu programa.'],
  },
];

export interface BentoCtaData {
  badgeTitle: string;
  badgeText: string;
  script: string;
  button: string;
  image: string;
}

export const BENTO_CTA: BentoCtaData = {
  badgeTitle: 'Parabéns!',
  badgeText: 'Você conquistou +500 pontos!',
  script: 'Engajamento que gera resultados!',
  button: 'Fale com um especialista',
  image: 'https://public.readdy.ai/ai/img_res/edited_6aaf20b6555a45f51712a06d84aa76c9_7e281da7.jpg',
};

export interface StackItem {
  badge: string;
  title: string;
  description: string;
  cta: string;
  image: string;
  tone: 'light' | 'soft';
  fullImage?: boolean;
}

export const STACK_ITEMS: StackItem[] = [
  {
    badge: 'Premiação',
    title: 'Pague premiação com a menor taxa do mercado',
    description:
      'Faça PIX ou coloque um cartão de crédito digital na mão do participante. É a forma mais simples e rápida de reconhecer resultados, com extrato e comprovante para todo mundo.',
    cta: 'Fale com um especialista',
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/9a58f9585f6d1f0795f1259ff231fd1e.png',
    tone: 'light',
    fullImage: true,
  },
  {
    badge: 'Engajamento',
    title: 'Comunicação é a chave do sucesso',
    description:
      'Tenha um time dedicado a manter o programa vivo. Seja em vídeo, push ou WhatsApp, a missão é engajar o participante e manter o foco na meta até o último dia da campanha.',
    cta: 'Agende uma demonstração',
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/03dc8989d469aff079698cd02051fead.png',
    tone: 'soft',
    fullImage: true,
  },
  {
    badge: 'Dados',
    title: 'Deixe a apuração de resultados com a gente',
    description:
      'Automatize todo o processo de dados da sua campanha. Os números entram, o resultado sai na ponta: para o gestor, em dashboards em tempo real, e para o participante, no app.',
    cta: 'Solicite uma demo gratuita',
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/d8b4eb7906eb0efe26c97ccd65b95482.png',
    tone: 'light',
    fullImage: true,
  },
  {
    badge: 'Sell-out',
    title: 'Comprove e ganhe com mecânicas de sell-out',
    description:
      'A melhor forma de premiar vendedores e balconistas no ponto de venda. O participante escaneia a nota, comprova a venda e pontua automaticamente, sem planilha e sem retrabalho.',
    cta: 'Conheça a plataforma',
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/61a3c6b5b05a9512bd70ca893594bba8.png',
    tone: 'soft',
    fullImage: true,
  },
  {
    badge: 'Reconhecimento',
    title: 'Transforme metas em experiências inesquecíveis',
    description:
      'Já pensou em premiar o seu time com uma viagem? Cuidamos do processo de ponta a ponta, do planejamento à execução, para que a conquista fique marcada na memória do participante.',
    cta: 'Fale com nosso time',
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/23382e42e29a3f2d84f5a59088c8e9dc.png',
    tone: 'light',
    fullImage: true,
  },
];

export interface ResultItem {
  icon: string;
  prefix: string;
  value: string;
  suffix: string;
  label: string;
  description: string;
}

export const RESULTS: ResultItem[] = [
  {
    icon: 'ri-building-2-fill',
    prefix: '+',
    value: '320',
    suffix: '',
    label: 'Empresas atendidas',
    description: 'Programas de incentivo ativos rodando na plataforma todos os dias.',
  },
  {
    icon: 'ri-team-fill',
    prefix: '+',
    value: '180',
    suffix: 'K',
    label: 'Participantes ativos',
    description: 'Vendedores, consultores e parceiros engajados em campanhas em andamento.',
  },
  {
    icon: 'ri-line-chart-fill',
    prefix: '+',
    value: '92',
    suffix: '%',
    label: 'Taxa de ativação',
    description: 'Dos convidados começam a usar a plataforma já na primeira semana da campanha.',
  },
];

export interface ResultTag {
  icon: string;
  label: string;
}

export const RESULT_TAGS: ResultTag[] = [
  { icon: 'ri-focus-2-line', label: 'Mais performance' },
  { icon: 'ri-group-line', label: 'Times mais engajados' },
  { icon: 'ri-trophy-line', label: 'Crescimento sustentável' },
];

export interface Segment {
  title: string;
  description: string;
  image: string;
  featured?: boolean;
}

export const SEGMENTS: Segment[] = [
  {
    title: 'Varejo',
    description:
      'Engaje vendedores de loja, gerentes e franqueados com campanhas que aumentam ticket médio e conversão nas lojas.',
    image:
      'https://readdy.ai/api/search-image?query=Confident%20retail%20store%20manager%20smiling%20while%20holding%20a%20tablet%20with%20sales%20data%20inside%20a%20modern%20supermarket%20aisle%2C%20warm%20natural%20light%2C%20professional%20editorial%20photography%2C%20clean%20composition&width=600&height=760&seq=gp-seg-varejo-09&orientation=portrait',
  },
  {
    title: 'Indústria e Canais',
    description:
      'Ative distribuidores, representantes e o time de campo com metas por canal, regiões e categorias de produto.',
    image:
      'https://readdy.ai/api/search-image?query=Engineers%20wearing%20hard%20hats%20reviewing%20a%20digital%20performance%20dashboard%20inside%20a%20modern%20clean%20manufacturing%20facility%2C%20bright%20professional%20industrial%20photography%20with%20cool%20tones&width=600&height=760&seq=gp-seg-industria-10&orientation=portrait',
  },
  {
    title: 'Serviços e Financeiro',
    description:
      'Incentive times comerciais de serviços, bancos e seguradoras com campanhas seguras, auditáveis e 100% aderentes às normas.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20business%20team%20collaborating%20around%20a%20glass%20table%20in%20a%20bright%20modern%20office%2C%20discussing%20performance%20charts%2C%20natural%20window%20light%2C%20corporate%20editorial%20photography%20with%20clean%20neutral%20tones&width=600&height=760&seq=gp-seg-servicos-11&orientation=portrait',
  },
  {
    title: 'Saúde e Planos de Saúde',
    description:
      'Especialistas em incentivo e fidelização para administradoras de planos de saúde, operadoras e redes hospitalares. Engaje beneficiários, reduza churn e aumente a adesão a programas de cuidado preventivo.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20editorial%20photograph%20of%20diverse%20healthcare%20professionals%20collaborating%20in%20a%20bright%20modern%20medical%20office%2C%20a%20doctor%20in%20white%20coat%20and%20health%20plan%20administrators%20reviewing%20patient%20engagement%20data%20on%20a%20tablet%2C%20warm%20natural%20window%20light%2C%20soft%20neutral%20warm%20tones%2C%20clean%20minimal%20composition%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=1000&height=700&seq=gp-seg-saude-12&orientation=landscape',
    featured: true,
  },
];

export interface CaseItem {
  tag: string;
  quote: string;
  metric: string;
  metricLabel: string;
}

export const CASES: CaseItem[] = [
  {
    tag: 'Case · Varejo',
    quote:
      '"Como operações de varejo aumentaram as vendas conectando campanhas de incentivo diretamente à performance das lojas."',
    metric: '+22%',
    metricLabel: 'de incremento em vendas no trimestre',
  },
  {
    tag: 'Case · Financeiro',
    quote:
      '"Como instituições financeiras aceleraram a venda de produtos estratégicos com campanhas segmentadas por meta."',
    metric: '+18%',
    metricLabel: 'na comercialização de produtos estratégicos',
  },
  {
    tag: 'Case · Indústria',
    quote:
      '"Como indústrias e canais de distribuição engajaram representantes e aumentaram o sell-out em todas as regiões."',
    metric: '+27%',
    metricLabel: 'de crescimento no sell-out do canal',
  },
];

export interface Prize {
  id: string;
  name: string;
  category: string;
  points: number;
  image: string;
  featured?: boolean;
}

export const PRIZE_CATEGORIES = [
  'Todos',
  'Dinheiro',
  'Cartão digital',
  'Vouchers',
  'Produtos',
  'Experiências',
];

export const PRIZES: Prize[] = [
  {
    id: 'pix-250',
    name: 'PIX turbinado',
    category: 'Dinheiro',
    points: 24000,
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/58d661ce0b65dcf1190730f53e7284ce.png',
  },
  {
    id: 'cartao-digital',
    name: 'Cartão digital pré-pago',
    category: 'Cartão digital',
    points: 19000,
    featured: true,
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/fe908d45e37ebf3574e88aff12af6c19.png',
  },
  {
    id: 'voucher-ifood',
    name: 'Catálogo de Vouchers',
    category: 'Vouchers',
    points: 5000,
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/4eec06f133c5f856cdcddb9c65ebb8ff.png',
  },
  {
    id: 'airfryer',
    name: 'Catálogo de Premios',
    category: 'Produtos',
    points: 15000,
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/f602df077783fab0f62c2544fef02a5a.png',
  },
  {
    id: 'resort',
    name: 'Experiências exclusivas',
    category: 'Experiências',
    points: 150000,
    featured: true,
    image:
      'https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/2aa9c63bfa7a3375911cc46bf86b19b0.png',
  },
];

export interface SupportPhase {
  step: string;
  icon: string;
  title: string;
  description: string;
  items: string[];
  tone: 'primary' | 'accent' | 'secondary';
}

export const SUPPORT_PHASES: SupportPhase[] = [
  {
    step: '01',
    icon: 'ri-gift-2-line',
    title: 'Recebimento',
    description:
      'O premiado sabe exatamente o que ganhou, como vai receber e em quanto tempo — sem precisar caçar informação em lugar nenhum.',
    items: ['Comunicação automática no resgate', 'Guia de resgate direto no prêmio', 'Prazo realista e transparente'],
    tone: 'primary',
  },
  {
    step: '02',
    icon: 'ri-truck-line',
    title: 'Entrega',
    description:
      'Acompanhamento proativo do status, do processamento até a chegada. Se algo der errado, o premiado não fica no escuro.',
    items: ['Rastreamento em tempo real', 'Suporte rápido em caso de problema', 'Resolução ágil'],
    tone: 'accent',
  },
  {
    step: '03',
    icon: 'ri-sparkling-2-line',
    title: 'Utilização',
    description:
      'A gente acompanha até o fim: passo a passo de como usar, aviso antes de expirar e um fechamento que gera depoimento.',
    items: ['Passo a passo de experiências', 'Alerta de validade do voucher', 'Pesquisa de satisfação pós-uso'],
    tone: 'secondary',
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQS: FaqItem[] = [
  {
    question: 'O que é a GetPoints?',
    answer:
      'A GetPoints é um ecossistema de incentivo que conecta metas, campanhas, comunicação, gamificação, dados e premiação em uma única plataforma. Ajudamos empresas a engajar equipes, ativar canais e transformar estratégia comercial em resultado.',
  },
  {
    question: 'Que tipos de campanhas eu posso criar?',
    answer:
      'Campanhas por meta de vendas, ranking, desafios por produto, sell-out com comprovação de nota fiscal, programas de indicação, treinamento gamificado e muito mais. Tudo configurável sem precisar de TI.',
  },
  {
    question: 'Como funciona a premiação dos participantes?',
    answer:
      'O participante acumula pontos e resgata em PIX, cartão digital, vouchers, produtos do marketplace ou experiências. O resgate é rápido, com extrato transparente e toda a documentação fiscal gerada automaticamente.',
  },
  {
    question: 'A plataforma é aderente às normas do Banco Central?',
    answer:
      'Sim. Operamos em alinhamento com as diretrizes das resoluções CMN 5.261 e BCB 518, através de instituições parceiras autorizadas, com segregação de contas, auditoria completa e trilha de rastreabilidade.',
  },
  {
    question: 'É possível integrar com o meu sistema atual?',
    answer:
      'Sim. A nossa API permite integrações com ERPs, CRMs, PDVs, aplicativos móveis e sistemas legados. Contamos com documentação completa, webhooks e suporte técnico especializado para a implantação.',
  },
  {
    question: 'Preciso instalar algo para o participante usar?',
    answer:
      'Não. A experiência do participante é 100% web e funciona muito bem no navegador do celular, sem download. Quem preferir também pode acessar pelo desktop ou tablet.',
  },
];

export interface FooterLink {
  label: string;
  target: string;
}

export interface FooterColumn {
  title: string;
  links: FooterLink[];
}

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    title: 'Plataforma',
    links: [
      { label: 'Plataforma', target: '/plataforma' },
      { label: 'Benefícios', target: '#solucoes' },
      { label: 'Como funciona', target: '#como-funciona' },
      { label: 'Segmentos', target: '#segmentos' },
      { label: 'Cases de sucesso', target: '#cases' },
    ],
  },
  {
    title: 'Soluções',
    links: [
      { label: 'Campanhas de incentivo', target: '/solicitar-demo' },
      { label: 'Gamificação e ranking', target: '/solicitar-demo' },
      { label: 'Premiação', target: '/solicitar-demo' },
      { label: 'Apuração de resultados', target: '/solicitar-demo' },
    ],
  },
  {
    title: 'Contato',
    links: [
      { label: 'Solicitar demonstração', target: '/solicitar-demo' },
      { label: 'contato@getpoints.com.br', target: 'mailto:contato@getpoints.com.br' },
      { label: '(11) 4003-5642', target: 'tel:+551140035642' },
      { label: 'São Paulo · SP', target: '#faq' },
    ],
  },
];

export interface SocialLink {
  label: string;
  href: string;
  icon: string;
}

export const SOCIAL_LINKS: SocialLink[] = [
  { label: 'LinkedIn da GetPoints', href: 'https://www.linkedin.com', icon: 'ri-linkedin-fill' },
  { label: 'Instagram da GetPoints', href: 'https://www.instagram.com', icon: 'ri-instagram-line' },
  { label: 'YouTube da GetPoints', href: 'https://www.youtube.com', icon: 'ri-youtube-fill' },
];